import * as React from "react"
import { CheckoutDetailsAutosave, type DraftDetails } from "../checkoutDetailsAutosave"

export function useCheckoutDetailsAutosave(inputs: {
    baseUrl: string; confirmationToken: string; enabled: boolean; values: DraftDetails
    detailsPanelRef: React.RefObject<HTMLElement>
}) {
    const { baseUrl, confirmationToken, enabled, values, detailsPanelRef } = inputs
    const current = React.useRef<CheckoutDetailsAutosave | null>(null)
    React.useEffect(() => {
        if (!confirmationToken) return
        const autosave = new CheckoutDetailsAutosave(`${baseUrl}/v1/booking-details-draft`, confirmationToken)
        current.current = autosave
        return () => { autosave.pause(); current.current = null }
    }, [baseUrl, confirmationToken])
    React.useEffect(() => {
        current.current?.update(values)
        current.current?.setActive(enabled)
    }, [baseUrl, confirmationToken, enabled, values])
    React.useEffect(() => {
        const flush = () => current.current?.flush()
        const blur = (event: FocusEvent) => {
            if (event.target instanceof Node && detailsPanelRef.current?.contains(event.target)) flush()
        }
        const hidden = () => { if (document.visibilityState === "hidden") flush() }
        document.addEventListener("focusout", blur)
        document.addEventListener("visibilitychange", hidden)
        window.addEventListener("pagehide", flush)
        window.addEventListener("online", flush)
        return () => {
            document.removeEventListener("focusout", blur)
            document.removeEventListener("visibilitychange", hidden)
            window.removeEventListener("pagehide", flush)
            window.removeEventListener("online", flush)
        }
    }, [detailsPanelRef])
    return {
        pause: () => { const autosave = current.current; autosave?.pause(); return autosave },
    }
}
